import React, { useState, useRef, useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
import { FaSearch, FaSpinner, FaCheckCircle, FaToggleOn, FaToggleOff, FaPen, FaSyncAlt, FaPenSquare, FaTrash, FaTimesCircle, FaUserPlus, FaUser, FaInfoCircle } from "react-icons/fa";
import "../../Complaint.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CommonContainer from "../Container/CommonContainer";
import toast from "react-hot-toast";
import { API_DOMAIN, FileIcons, TYPE_Of_CASE } from "../../Common/CommonVariables";
import * as UserService from '../../Services/User/UserService'
import 'react-datepicker/dist/react-datepicker.css';
import LoadingSpinnerComponent from "../Loader/LoadingSpinnerComponent";
import { store } from "../../Store/store";
import MultiSelect from 'multiselect-react-dropdown';
import ExtendUserComponent from "../PartnerList/ExtendUserComponent";
import { User } from "lucide-react";
import Popover from "../../Common/Popper";

const UserListComponent = () => {
  const [newUserShow, setNewUserShow] = useState(false);
  const [isEditUser, setIsEditUser] = useState(false);
  const [roleChanged, setRoleChanged] = useState(false);


  const [filteredUserList, setFilteredUserList] = useState([]);
  const [ActiveRoleList, setActiveRoleList] = useState([]);

  // const { register, handleSubmit, formState: { errors }, reset, } = useForm();

  const [selectedUser, setSelectedUser] = useState({});

  const [loading, setLoading] = useState(false);
  // const [SearchLoading, setSearchLoading] = useState(false);
  const selectedSearchUser = useRef();

  const { register, handleSubmit, watch, formState: { errors }, reset } = useForm();

  const selectedRoleId = watch("RoleId");


  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Set number of items per page

  const indexOfLastUser = currentPage * itemsPerPage;
  const indexOfFirstUser = indexOfLastUser - itemsPerPage;
  const currentUsers = filteredUserList.slice(indexOfFirstUser, indexOfLastUser);

  //Extended 
  const [selectedPartnerUser, setSelectedPartnerUser] = useState({});
  const [extendUserList, setExtendUserList] = useState(false);

  const userInfo = store.getState();

  const fetchUserList = useCallback(() => {
    UserService.GetUniversalFilterUserData("")
      .then(({ data }) => {
        if (data.IsSuccess) {
          setFilteredUserList(data.Data);
        }
      })
      .catch(() => toast.error("Something went wrong."));
  }, []);

  useEffect(() => {
    GetUserDependedFeildDataList();
    fetchUserList();
  }, [fetchUserList]);

  const fetchUniversalFilterUserData = () => {

    if (!selectedSearchUser.current.value) {
      window.location.reload()
      return;
    }
    UserService.GetUniversalFilterUserData(selectedSearchUser.current.value)
      .then(({ data }) => {
        if (data.IsSuccess) {
          setFilteredUserList(data.Data);
        }
        else {
          setFilteredUserList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."));
  };


  const handleViewUserDetailById = (userId) => {
    setIsEditUser(true)
    fetchAccessControlMasterList(userId);
    UserService.GetUserDetailById(userId).then(({ data }) => {
      if (data.IsSuccess) {
        setSelectedUser(data.Data);
        setNewUserShow(true);
        setRoleChanged(false)
      } else {
        setSelectedUser({})
        // toast.error("No Data found for selected range");
      }
    })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() => { }
        //setLoading(false)
      );
  };
  const handleNewUserClose = () => {
    reset();
    setSelectedUser([]);
    setNewUserShow(false)
  };

useEffect(() => {
  if (!selectedRoleId) return;

  if (isEditUser && String(selectedRoleId) === String(selectedUser?.RoleId)) {
    if (roleChanged) {
      setRoleChanged(false);
      fetchAccessControlMasterList(selectedUser.UserId);
    }
    return;
  }

  UserService.GetRoleAccessMappingByRoleId(selectedRoleId)
    .then(({ data }) => {
      if (data.IsSuccess) {
        const normalized = data.Data.map(item => ({
          ...item,
          IsSelected: true,
          IsDeleted: false
        }));
        setAccessControlMasterListByRoleId(normalized);
      } else {
        setAccessControlMasterListByRoleId([]);
      }
    })
    .catch(() => toast.error("Failed to load role access"));

}, [selectedRoleId, isEditUser, selectedUser?.RoleId, roleChanged]);

  const onSubmit = (data) => {
    // data.UserRightsDet = accessControlMasterList;

    data.UserRightsDet = mergedAccessList.filter(
      a => a.IsSelected || a.IsDeleted
    );

    //debugger;
    if (selectedUser?.UserId) {
      data.UserId = selectedUser?.UserId;
      UserService.UpdateUser(data)
        .then(({ data }) => {
          if (data.IsSuccess) {
            fetchUserList();
            toast.success("User updated successfully!");
            handleNewUserClose();
          } else {
            toast.error("Something went wrong during update.");
          }
        })
        .catch(() => toast.error("Something went wrong during update."))
        .finally(() => { });
    } else {

      UserService.CreateUser(data)
        .then(({ data }) => {
          if (data.IsSuccess) {
            fetchUserList();
            // GetUserDependedFeildDataList();
            toast.success("User saved successfully!");
            handleNewUserClose();
          } else {
            toast.error(data.ResponseMessage);
          }
        })
        .catch(() => toast.error("Something went wrong during creation."))
        .finally(() => { });
      
    }
  };

  const GetUserDependedFeildDataList = () => {
    UserService.GetUserDependedFeildDataList().then(({ data }) => {
      //debugger;
      if (data.IsSuccess) {
        setActiveRoleList(data.Data.RoleList)
      } else {
      }
    })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() => { }
        //setLoading(false)
      );
  };

  const handleActivateDeActivateUser = (rec) => {

    UserService.ActivateDeactivateUser(rec.UserId, !rec.IsActive).then(data => {
      if (data.data.IsSuccess) {
        const message = rec.IsActive ? "User DeActivated Successfully" : "User Activated Successfully";
        toast.success(message);
        fetchUserList();
      } else {
        toast.error("Somthing went wrong");
      }
    }).catch(error => {
      toast.error("Somthing went wrong");
    })

  };

  const [accessControlMasterList, setAccessControlMasterList] = useState([]);
  const [accessControlMasterListByRoleId, setAccessControlMasterListByRoleId] = useState([]);

  const mergedAccessList = React.useMemo(() => {
    if (!accessControlMasterList || accessControlMasterList.length === 0) return [];

    if (!isEditUser) {
      return accessControlMasterList.map(access => {
        const mapped = accessControlMasterListByRoleId.find(
          r => r.Access_Control_Id === access.Access_Control_Id
        );

        return {
          ...access,
          IsSelected: !!mapped && !mapped.IsDeleted,
          IsDeleted: mapped?.IsDeleted ?? false
        };
      });
    }

    if (isEditUser && roleChanged) {
      return accessControlMasterList.map(access => {
        const mapped = accessControlMasterListByRoleId.find(
          r => r.Access_Control_Id === access.Access_Control_Id
        );

        return {
          ...access,
          IsSelected: !!mapped && !mapped.IsDeleted,
          // IsDeleted: mapped?.IsDeleted ?? false,
          IsDeleted: mapped ? (mapped.IsDeleted ?? false) : access.IsSelected,
          UserId: selectedUser?.UserId
        };
      });
    }

    return accessControlMasterList.map(access => ({
      ...access,
      UserId: selectedUser?.UserId
    }));

  }, [
    accessControlMasterList,
    accessControlMasterListByRoleId,
    selectedUser,
    isEditUser,
    roleChanged
  ]);


  const fetchAccessControlMasterList = (userid) =>{

    UserService.GetAccessControlMasterList(userid, null)
    .then(data =>{
      //debugger;
      if(data.data.IsSuccess){
        setAccessControlMasterList(data.data.Data)
      }
      else{
        setAccessControlMasterList();
      }
    })
    .catch(error =>{
      toast.error("Something went wrong")
    })
    .finally(() =>{

    })
  }

  const handleMappingDelete = (Access_Control_Id) => {
  if (isEditUser && !roleChanged) {
    setAccessControlMasterList(prev =>
      prev.map(item =>
        item.Access_Control_Id === Access_Control_Id
          ? { ...item, IsDeleted: true, IsSelected: false, UserId: selectedUser?.UserId }
          : item
      )
    );
  } else {
    setAccessControlMasterListByRoleId(prev =>
      prev.map(item =>
        item.Access_Control_Id === Access_Control_Id
          ? { ...item, IsDeleted: true, IsSelected: false }
          : item
      )
    );
  }
};

const handleMappingInsert = (Access_Control_Id) => {
  if (isEditUser && !roleChanged) {
    setAccessControlMasterList(prev =>
      prev.map(item =>
        item.Access_Control_Id === Access_Control_Id
          ? { ...item, IsSelected: true, IsDeleted: false, UserId: selectedUser?.UserId }
          : item
      )
    );
  } else {
    setAccessControlMasterListByRoleId(prev => {
      const exists = prev.find(p => p.Access_Control_Id === Access_Control_Id);
      if (exists) {
        return prev.map(item =>
          item.Access_Control_Id === Access_Control_Id
            ? { ...item, IsSelected: true, IsDeleted: false }
            : item
        );
      }
      return [
        ...prev,
        { Access_Control_Id, IsSelected: true, IsDeleted: false, UserId: selectedUser?.UserId }
      ];
    });
  }
};

const getShortName = (first, last, limit = 25) => {
    const full = `${first || ""} ${last || ""}`.trim();
    if (!full) return "-";
    return full.length > limit ? full.substring(0, limit) + "..." : full;
};

  return (
    <>
      {/* <LoadingSpinnerComponent></LoadingSpinnerComponent> */}
      <CommonContainer icon={<FaUser size={20}/>} heading="User List" buttonText="Add User" onButtonClick={() => { reset(); setSelectedUser([]); setIsEditUser(false); setRoleChanged(false);setAccessControlMasterListByRoleId([]); setNewUserShow(true); fetchAccessControlMasterList(); }}>

        <div className="d-flex align-items-center justify-content-between mb-2">
          <div className="d-flex align-items-center gap-2">
          </div>
          <div className="search-box" style={{ position: "relative", width: "320px" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Search"
              ref={selectedSearchUser}
              style={{
                paddingRight: "35px",
                borderRadius: "5px",
                border: "1px solid #ddd",
              }}
            />
            <button
              type="button"
              className="btn custom-sumbitbtn d-flex align-items-center justify-content-center"
              style={{
                padding: '5px',
                position: "absolute",
                right: "0px",
                height: "35px",
                width: "45px",
                top: "50%",
                borderTopLeftRadius: "0",
                borderBottomLeftRadius: "0",
                transform: "translateY(-50%)",
              }}
              onClick={fetchUniversalFilterUserData}
            >
              <FaSearch />
            </button>

          </div>
          {/* <button
            className="btn btn-danger d-flex align-items-center justify-content-center"
            style={{ width: "38px", height: "35px", padding: "0" }}
            onClick={() => window.location.reload()}
            disabled={loading}
          >
            <FaSyncAlt />
          </button> */}
        </div>
        <div>
          <div className="table-responsive" >
            <table className="table table-bordered custom-table" >
              <thead>
                <tr>
                  <th style={{ width: "30%" }}> User Name </th>
                  <th style={{width: "25%"}}> Email Id </th>
                  <th style={{width: "9%"}}> Mobile No </th>
                  <th style={{width: "7%"}}> Fed Id</th>
                  <th style={{width: "10%"}}> Role Name</th>
                  <th style={{width: "7%"}}> Ad User </th>
                  <th style={{width: "6%"}}> Active </th>
                  <th style={{width: "6%"}}> Action </th>
                </tr>
              </thead>
              <tbody>
                {
                  currentUsers.length > 0 ? (
                    currentUsers.map((rec, index) => (
                      <tr key={index} >
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                          {rec.Partner_Code && (
                            <Popover 
                            content={
                              <div style={{ textAlign: "left" }}>
                                <p><strong>Partner Code:</strong> {rec.Partner_Code || "-"}</p>
                                <p><strong>Partner Name:</strong> {rec.Partner_Name || "-"}</p>
                              </div>
                            }>
                            <FaInfoCircle color="green" size={13} className="mb-1" style={{ cursor: "pointer" }} /> &nbsp;
                            </Popover>
                          )}
                          <strong>
                              {getShortName(rec.FirstName, rec.LastName)}
                          </strong>
                        </td >
                        <td> {rec.EmailId} </td>
                        <td> {rec.MobileNo} </td>
                        <td> {rec.FedId} </td>
                        <td> {rec.Role_Name} </td>
                        <td>
                          {rec.Is_Ad_Login ? <FaCheckCircle color="green" /> : <FaTimesCircle color="red" />}
                        </td>
                        <td>
                          {rec.IsActive ? <FaToggleOn title="Deactivate User" onClick={() => handleActivateDeActivateUser(rec)} color="green" size={16} /> : <FaToggleOff onClick={() => handleActivateDeActivateUser(rec)} title="Activate User" color="red" size={16} />}
                        </td>
                        <td>
                          {/* <FaPenSquare color="green" className="mr-2 cursor-pointer" size={25} onClick={() => handleViewUserDetailById(rec.UserId)} title="Edit User" /> */}
                          <FaPen color="green" className="mr-2 cursor-pointer" onClick={() => handleViewUserDetailById(rec.UserId)} title="Edit User" />
                          {/* <FaTrash color={"red"} onClick={() => handleUserDelete(rec)} /> */}
                          { rec.Partner_Code && rec.Is_Parent && <FaUserPlus
                            size={17}
                            color="green"
                            className="cursor-pointer"
                            title="Extend User"
                            onClick={() => {
                              setExtendUserList(true);
                              setSelectedPartnerUser(rec);
                            }}
                          />}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr><td colSpan="9" className="text-center" > No User found </td></tr >
                  )}
              </tbody>
            </table>
          </div>

          {
            filteredUserList.length > itemsPerPage ? (
              <div className="d-flex justify-content-center">
                <nav>
                  <ul className="pagination">
                    <li className="page-item">
                      <button
                        style={{ color: 'green' }}
                        className="page-link"
                        onClick={() => setCurrentPage(1)}
                      >
                        First
                      </button>
                    </li>

                    {(() => {
                      const totalPages = Math.ceil(filteredUserList.length / itemsPerPage);
                      const maxPagesToShow = 5;
                      let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
                      let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

                      if (endPage - startPage + 1 < maxPagesToShow) {
                        startPage = Math.max(1, endPage - maxPagesToShow + 1);
                      }

                      return [...Array(endPage - startPage + 1)].map((_, index) => (
                        <li key={index} style={{ color: 'green' }} className="page-item">
                          <button
                            style={{
                              color: 'green',
                              border: currentPage === startPage + index ? '2px solid green' : '2px solid #ccc',
                              backgroundColor: currentPage === startPage + index ? '#e6ffe6' : 'transparent',
                              borderRadius: '0',
                              padding: '5px 10px',
                              cursor: 'pointer',
                              zIndex: currentPage === startPage + index ? '2' : '1',
                              position: 'relative',
                            }}
                            className="page-link"
                            onClick={() => setCurrentPage(startPage + index)}
                          >
                            {startPage + index}
                          </button>
                        </li>
                      ));
                    })()}

                    <li className="page-item">
                      <button
                        className="page-link"
                        onClick={() =>
                          setCurrentPage(Math.ceil(filteredUserList.length / itemsPerPage))
                        }
                        style={{ color: 'green' }}
                      >
                        Last
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>

            ) : null}

        </div>
        {newUserShow && (
          <div className="modal-backdrop">
            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
              <div className="modal-dialog modal-lg custom-modal" role="document">
                <div className="modal-content mb-0 p-0">
                  <div className="modal-header p-2-5">
                    <h5 className="modal-title">{selectedUser?.FirstName ? "Edit User" : "New User"}</h5>
                    <button type="button" className="btn-close" onClick={handleNewUserClose}></button>
                  </div>
                  <div className="modal-body p-1">
                    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                      <div className="container mb-0" style={{ fontSize: "13px" }}>

                        <div className="row">

                          <div className="col-md-4 mb-2">
                            <label className="fw-bold required mb-0-5">First Name</label>
                            <input type="text" className="form-control" placeholder="Enter First Name" {...register("FirstName", { required: "First Name is required" })} defaultValue={selectedUser?.FirstName || ""} />
                            {errors.FirstName && <p className="text-danger required_error">{errors.FirstName.message}</p>}
                          </div>
                          <div className="col-md-4 mb-2">
                            <label className="fw-bold required mb-0-5">Last Name</label>
                            <input type="text" className="form-control" placeholder="Enter Last Name" {...register("LastName", { required: "Last Name is required" })} defaultValue={selectedUser?.LastName || ""} />
                            {errors.LastName && <p className="text-danger required_error">{errors.LastName.message}</p>}
                          </div>
                          <div className="col-md-4 mb-2">
                            <label className="fw-bold required mb-0-5">Mobile No</label>
                            {/* <input type="text" className="form-control" placeholder="Enter Mobile No" {...register("MobileNo")} defaultValue={selectedUser?.MobileNo || ""} />
                            {errors.MobileNo && <p className="text-danger required_error">{errors.MobileNo.message}</p>} */}
                            <input type="text" placeholder="Enter Mobile No" className="form-control" defaultValue={selectedUser?.MobileNo || ""}  {...register("MobileNo", {
                              required: "Customer Mobile is required", pattern: { value: /^[0-9]+$/, message: "Only numbers are allowed", },
                              minLength: { value: 10, message: "Mobile number must be at least 10 digits", },
                              maxLength: { value: 10, message: "Mobile number must not exceed 10 digits", },
                            })}
                              onInput={(e) => (e.target.value = e.target.value.replace(/\D/g, ""))} />
                            {errors.MobileNo && (
                              <p className="text-danger required_error">
                                {errors.MobileNo.message}
                              </p>
                            )}
                          </div>

                        </div>

                        <div className="row">

                          <div className="col-md-4 mb-2">
                            <label className="fw-bold required mb-0-5">Email Id</label>
                            <input
                              type="email"
                              className="form-control"
                              placeholder="Enter Email Id"
                              defaultValue={selectedUser?.EmailId || ""}
                              {...register("EmailId", {
                                required: "Email Id is required",
                                pattern: {
                                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                  message: "Invalid email address",
                                },
                              })}
                            />
                            {errors.EmailId && <p className="text-danger required_error">{errors.EmailId.message}</p>}
                          </div>
                          {userInfo?.userData?.Role_Name == "Admin" && (
                            <div className="col-md-4 mb-2">
                              <label className="fw-bold mb-0-5">Password</label>
                              <input type="password" className="form-control" disabled placeholder={selectedUser?.UserId ? "" : "Auto generate password"} {...register("Password")} defaultValue={selectedUser?.Password || ""} />
                              {errors.Password && <p className="text-danger required_error">{errors.Password.message}</p>}
                            </div>
                          )}
                          <div className="col-md-4 mb-2">
                            <label className="fw-bold required mb-0-5">Role</label>
                            <select className="form-select" {...register("RoleId", { required: "Role is required",  onChange: () => {
                            if (isEditUser) {
                              setRoleChanged(true);
                            }}})} defaultValue={selectedUser?.RoleId || ""} >
                              <option value="">Select Role</option>
                              {ActiveRoleList.map((item) => (
                                <option key={item.Role_Id} value={item.Role_Id}>
                                  {item.Role_Name}
                                </option>
                              ))}
                            </select>
                            {errors.RoleId && <p className="text-danger required_error">{errors.RoleId.message}</p>}
                          </div>

                        </div>

                        <div className="row">

                          <div className="col-md-4 mb-2">
                            <label className="fw-bold mb-0-5">Emp Code</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Emp Code"
                              {...register("Emp_Code", {
                                maxLength: {
                                  value: 30,
                                  message: "Emp Code cannot exceed 30 characters",
                                },
                              })}
                              defaultValue={selectedUser?.Emp_Code || ""}
                            />
                            {errors.Emp_Code && <p className="text-danger required_error">{errors.Emp_Code.message}</p>}
                          </div>

                          <div className="col-md-4 mb-2">
                            <label className="fw-bold mb-0-5">Fed Id</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Fed Id"
                              {...register("FedId", {
                                maxLength: {
                                  value: 30,
                                  message: "Fed Id cannot exceed 30 characters",
                                },
                              })}
                              defaultValue={selectedUser?.FedId || ""}
                            />
                            {errors.FedId && <p className="text-danger required_error">{errors.FedId.message}</p>}
                          </div>
                          <div className="col-md-4 mb-2">
                            <div className="row mt-4">
                              <div className="col-6">
                                <div className="form-check">
                                  <input type="checkbox" className="form-check-input" {...register("IsOtp")} defaultChecked={selectedUser?.IsOtp || false} />
                                  <label className="form-check-label fw-bold">Is Otp</label>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="form-check">
                                  <input type="checkbox" className="form-check-input" {...register("Is_Ad_Login")} defaultChecked={selectedUser?.Is_Ad_Login || false} />
                                  <label className="form-check-label fw-bold">Is Ad Login</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4 mb-2">
                            <label className="fw-bold mb-0-5">User Access</label>
                            <MultiSelect
                              options={mergedAccessList}
                              selectedValues={mergedAccessList.filter(access => access.IsSelected)}
                              displayValue="Access_Control_Name"
                              onSelect={(selectedList, selectedItem) => handleMappingInsert(selectedItem.Access_Control_Id)}
                              onRemove={(selectedList, removedItem) => handleMappingDelete(removedItem.Access_Control_Id)}
                              placeholder="Select Allowed Access"
                            />
                            {/* <MultiSelect
                              options={accessControlMasterList}
                              selectedValues={accessControlMasterList.filter(access => access.IsSelected)}
                              displayValue="Access_Control_Name"
                              onSelect={(selectedList, selectedItem) => handleMappingInsert(selectedItem.Access_Control_Id)}
                              onRemove={(selectedList, removedItem) => handleMappingDelete(removedItem.Access_Control_Id)}
                              placeholder="Select Allowed Access"
                            /> */}
                          </div>
                        </div>

                      </div>

                      <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                        <button type="button" className="btn btn-danger" onClick={handleNewUserClose}>Close</button>
                        <button type="submit" className="btn btn-primary">{selectedUser?.UserId ? "Update" : "Save"}</button>
                      </div>

                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {extendUserList && (<ExtendUserComponent selectedPartner_Code = {selectedPartnerUser.Partner_Code} selectedPartnerUser= {selectedPartnerUser} setExtendUserList = {setExtendUserList}/>)}

      </CommonContainer >
    </>
  );
};

export default UserListComponent;